export enum ChargingTermsType {
  DueOnReceipt,
  Net10,
  Net15,
  Net30,
  Net60
}
